import api from "../lib/api";

export const adminAuthService = {
  me: async () => {
    const { data } = await api.get("/auth/me");
    return data;
  },
  login: async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return data;
  },
  forgotPassword: async (email) => {
    const { data } = await api.post("/auth/admin/forgot-password", { email });
    return data;
  },
  verifyOtp: async (resetToken, otp) => {
    const { data } = await api.post("/auth/admin/verify-otp", { reset_token: resetToken, otp });
    return data;
  },
  resetPassword: async (passwordResetToken, newPassword) => {
    const { data } = await api.post("/auth/admin/reset-password", {
      password_reset_token: passwordResetToken,
      new_password: newPassword,
    });
    return data;
  },
};

export const customerAuthService = {
  login: async (email, password) => {
    const { data } = await api.post("/auth/customer/login", { email, password });
    return data;
  },
  signup: async (name, email, phone, password) => {
    const { data } = await api.post("/auth/customer/signup", { name, email, phone, password });
    return data;
  },
  googleUrl: async (redirectAfter) => {
    const { data } = await api.get("/auth/customer/google/url", {
      params: { redirect_after: redirectAfter },
    });
    return data;
  },
  completeGoogleLogin: async (code, state) => {
    const { data } = await api.post("/auth/customer/google/callback", { code, state });
    return data;
  },
  me: async () => {
    const { data } = await api.get("/auth/customer/me");
    return data;
  },
  updateMe: async (payload) => {
    const { data } = await api.put("/auth/customer/me", payload);
    return data;
  },
  forgotPassword: async (identifier) => {
    const { data } = await api.post("/auth/customer/forgot-password", { identifier });
    return data;
  },
  verifyOtp: async (resetToken, otp) => {
    const { data } = await api.post("/auth/customer/verify-otp", { reset_token: resetToken, otp });
    return data;
  },
  resetPassword: async (passwordResetToken, newPassword) => {
    const { data } = await api.post("/auth/customer/reset-password", {
      password_reset_token: passwordResetToken,
      new_password: newPassword,
    });
    return data;
  },
};
